import Cookies from "js-cookie";

const TokenKey = "User-Token";

let time = new Date(new Date().getTime() + 3 * 60 * 60 * 1000);

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey,  token, {
        expires: time
    });
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}

export default {};
